import { Component, AfterViewInit, OnChanges, EventEmitter, Input, Output, ElementRef, Renderer } from '@angular/core';
import { ConfirmationService } from 'primeng/primeng';

@Component({
    selector: 'cui-confirm-dialog',
    templateUrl: './cui-confirm-dialog.component.html'
})
export class CUIConfirmDialogComponent implements AfterViewInit, OnChanges {
    @Input() show: boolean;
    @Input() icon: string;
    @Input() title: string = 'Confirmation';
    @Input() message: string = 'Are you sure that you want to perform this action?';
    @Input() confirmLabel: string = 'Yes';
    @Input() cancelLabel: string = 'No';
    @Output() onConfirm: EventEmitter<any> = new EventEmitter();

    listener: Function;

    constructor(
        private confirmationService: ConfirmationService,
        private elementRef: ElementRef, 
        private renderer: Renderer
    ) { }

    ngAfterViewInit(): void {
        let closeButton = this.elementRef.nativeElement.querySelector('.ui-dialog-titlebar-close');
        this.listener = this.renderer.listen(closeButton, 'click', (event) => {
            this.emitConfirm(false);
        });
    }

    ngOnChanges(changes: any) : void {
        if (changes.show && changes.show.currentValue == true) {
            this.showConfirmDialog();
        }
    }

    ngOnDestroy() {
        this.listener();
    }

    showConfirmDialog() {
        this.confirmationService.confirm({
            message: this.message,
            accept: () => {
                this.emitConfirm(true);
            },
            reject: () => {
                this.emitConfirm(false);
            }
        });
    }

    /**
     * @function emits a onConfirm event to the implementing feature component when the confirm or cancel button is clicked
     * @returns void
     */
    emitConfirm(response: boolean): void {
        this.onConfirm.emit({ response: response });
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-confirm-dialog/cui-confirm-dialog.component.ts